import styled from "styled-components"

const CustomArrows = styled.button`
  border: none;
  background-color: transparent;
  &:hover {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`

export { CustomArrows }
